export default __webpack_public_path__ + "static/media/pinterest.919e1d83.jpg";